var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocument = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 12H8v2h6zM8 17h14v2H8zM18 22H8v2h10z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 1.5A1.5 1.5 0 0 1 4.5 0h14.31a1.5 1.5 0 0 1 .996.379l8.69 7.724A1.5 1.5 0 0 1 29 9.225V30.5a1.5 1.5 0 0 1-1.5 1.5h-23A1.5 1.5 0 0 1 3 30.5zM5 2v28h22V10h-7.5A1.5 1.5 0 0 1 18 8.5V2zm15 1.227L25.37 8H20z",
  clipRule: "evenodd"
})));
export default SvgDocument;